export default {
  'stopPayment.duration': 'Stop Duration',
  'stopPayment.fromIsPositive': 'From must be greater than 0',
  'stopPayment.issueDate': 'Issue Date',
  'stopPayment.legend': 'Stop Payment',
  'stopPayment.maxlength': 'Max Length',
  'stopPayment.payee': 'Payee',
  'stopPayment.rangeError': 'The range must be less than <%= range %>',
  'stopPayment.reason': 'Stop Reason',
  'stopPayment.toFromError': 'To must be greater than From',
  'stopPayment.months': 'months'
};
